import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import { IPagination } from 'app/types/common';
import { OrganisationsActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const resetOrganisations = (): any => action(types.RESET_ORGANISATIONS);

export const createOrganisation = (data): any => action(types.CREATE_ORGANISATION_REQUESTED, data);

export const updateOrganisation = (data): any => action(types.UPDATE_ORGANISATION_REQUESTED, data);

export const deleteOrganisation = (organisationId): any => action(types.UPDATE_ORGANISATION_REQUESTED, organisationId);

export const getOrganisation = (organisationId): any => action(types.GET_ORGANISATION_REQUESTED, organisationId);

export const getAllOrganisations = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_ORGANISATIONS_REQUESTED, { pagination, compile });

export const selectOrganisation = (organisationId): any => action(types.SELECT_ORGANISATION_REQUESTED, {
  currentOrganisationId: organisationId,
});

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createOrganisationPending: (payload): any => action(types.CREATE_ORGANISATION_PENDING, payload),
  createOrganisationSuccess: (response): any => action(types.CREATE_ORGANISATION_SUCCESS, {
    organisationsById: response.entities.organisations,
    currentOrganisationId: response.result,
  }),
  updateOrganisationPending: (payload): any => action(types.UPDATE_ORGANISATION_PENDING, payload),
  updateOrganisationSuccess: (response): any => action(types.UPDATE_ORGANISATION_SUCCESS, {
    organisationsById: response.entities.organisations,
    currentOrganisationId: response.result,
  }),
  updateOrganisationFailed: (error): any => action(types.UPDATE_ORGANISATION_FAIL, { backendErrors: error }),
  deleteOrganisationPending: (): any => action(types.UPDATE_ORGANISATION_PENDING, {}),
  deleteOrganisationSuccess: (response, userId): any => {
    localStorage.set(userId, { currentOrganisationId: null });

    return action(types.DELETE_ORGANISATION_SUCCESS, {
      currentOrganisationId: response,
    });
  },
  getOrganisationPending: (): any => action(types.GET_ORGANISATION_PENDING, {}),
  getOrganisationSuccess: (response): any => action(types.GET_ORGANISATION_SUCCESS, {
    organisationsById: response.entities.organisations,
    currentOrganisationId: response.result,
  }),
  getOrganisationFailed: (error): any => action(types.GET_ORGANISATION_FAIL, { backendErrors: error }),
  deleteOrganisationFailed: (error): any => action(types.UPDATE_ORGANISATION_FAIL, { backendErrors: error }),
  getAllOrganisationsPending: (pagination): any => action(types.GET_ALL_ORGANISATIONS_PENDING, { pagination }),
  getAllOrganisationsSuccess: (response, meta): any => action(types.GET_ALL_ORGANISATIONS_SUCCESS, {
    organisationsById: response.entities.organisations,
    organisationIds: response.result,
    meta,
  }),
  getAllOrganisationsFailed: (error) => action(types.GET_ALL_ORGANISATIONS_FAIL, { backendErrors: error }),
  createOrganisationFailed: (error): any => action(types.CREATE_ORGANISATION_FAIL, { backendErrors: error }),
};

export default null;
